"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientConnectedToCatalystIn = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var CatalystClient_1 = require("../CatalystClient");

var catalystList_1 = require("./catalystList");

var common_1 = require("./common");

var FETCH_HEALTH_TIMEOUT = '10s';
/**
 * Returns a CatalystClient connected to one of the catalysts in the given network
 */

function clientConnectedToCatalystIn(_x, _x2) {
  return _clientConnectedToCatalystIn.apply(this, arguments);
}

function _clientConnectedToCatalystIn() {
  _clientConnectedToCatalystIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(network, origin) {
    var noContractList, list, shuffled, _iterator, _step, catalystUrl, client, isUp;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return catalystList_1.getUpdatedApprovedListWithoutQueryingContract({
              preKnownServers: {
                network: network
              },
              origin: origin
            });

          case 2:
            noContractList = _context.sent;

            if (!noContractList) {
              _context.next = 7;
              break;
            }

            list = noContractList;
            _context.next = 11;
            break;

          case 7:
            console.warn('Falling back to the smart contract to get an updated list of active servers');
            _context.next = 10;
            return catalystList_1.getApprovedListFromContract(network);

          case 10:
            list = _context.sent;

          case 11:
            shuffled = common_1.shuffleArray(list);
            _iterator = _createForOfIteratorHelper(shuffled);
            _context.prev = 13;

            _iterator.s();

          case 15:
            if ((_step = _iterator.n()).done) {
              _context.next = 25;
              break;
            }

            catalystUrl = _step.value;
            client = new CatalystClient_1.CatalystClient(catalystUrl, origin);
            _context.next = 20;
            return isServerUp(client);

          case 20:
            isUp = _context.sent;

            if (!isUp) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", client);

          case 23:
            _context.next = 15;
            break;

          case 25:
            _context.next = 30;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](13);

            _iterator.e(_context.t0);

          case 30:
            _context.prev = 30;

            _iterator.f();

            return _context.finish(30);

          case 33:
            throw new Error("Couldn't find a server on the ".concat(network, " network that was up"));

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 27, 30, 33]]);
  }));
  return _clientConnectedToCatalystIn.apply(this, arguments);
}

exports.clientConnectedToCatalystIn = clientConnectedToCatalystIn;

function isServerUp(_x3) {
  return _isServerUp.apply(this, arguments);
}

function _isServerUp() {
  _isServerUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var result, isSomeServerDown;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return client.fetchPeerHealth({
              timeout: FETCH_HEALTH_TIMEOUT
            });

          case 3:
            result = _context2.sent;
            isSomeServerDown = Object.keys(result).some(function (service) {
              return result[service] !== dcl_catalyst_commons_1.HealthStatus.HEALTHY;
            });
            return _context2.abrupt("return", !isSomeServerDown);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", false);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _isServerUp.apply(this, arguments);
}